import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from '../../PageContainer';
import { ActionPlan } from './ActionPlan';

export const ActionPlanPage = ({ history }: RouteComponentProps) => {
  return (
    <PageContainer history={history}>
      <ActionPlan />
    </PageContainer>
  );
};
